import { useContext } from 'react';
import { EventTrackingContext } from './EventTrackingContext';

export default function useEventTracking() {
  const context = useContext(EventTrackingContext);

  if (context === undefined) {
    throw new Error('useEventTracking must be used with EventTrackingProvider');
  }

  return context;
}
